import { useState, useCallback } from 'react';
import { isArmenianCountry } from '../helpers/countryHelper';

export default function useSocCardStatus(setValue) {
  const [socCardEnabled, toggleSocCardStatus] = useState(false);

  const citizenshipUpdate = useCallback((country) => {
    const isArmCountry = isArmenianCountry(country);
    if (!isArmCountry) {
      setValue('socCard', '');
    }
    toggleSocCardStatus(isArmCountry);
  }, [setValue]);

  return [socCardEnabled, citizenshipUpdate];
}
